<template lang="pug">
  DataTablePage(
    mainColumn="name"
    longColumn="remark"
    :resource="resource"
    title="档案查询"
    label="区本"
    labelName="name"
    :operation="operation"
    :operationWidth="113"
    :tableFullList="tableFullList"
    :tableInitList="tableInitList"
    :filterFullList="filterFullList"
    :filterInitList="filterInitList"
    :updateList="updateList"
    :columns="columns")
    SmartDialog(
      v-model="dialogVisible"
      :title="dialogTitle"
      :size="dialogSize")
      MapsPage(
        v-if="dialogVisible"
        :zoom="zoom"
        :center="center"
        :markers="markers"
        :columns="mapColumns"
        :resource="mapResource")
</template>

<script>
import DataTablePage from '@/containers/DataTablePage'
import SmartDialog from '@/components/SmartDialog'
import MapsPage from '@/containers/MapsPage'
import { operationUpdate } from '@/containers/DataTablePage/operation'
import fullColumns from '@/containers/meterReading/fullColumns'
// import { checkActions } from '@/utils/auth'

export default {
  name: 'Book',
  components: {
    DataTablePage,
    SmartDialog,
    MapsPage
  },
  data () {
    // const hasUpdate = checkActions('/system/menu/update')
    return {
      dialogVisible: false,
      dialogTitle: '查看地图',
      dialogSize: 'lg',
      zoom: 13,
      center: [102.7289187150, 25.0729624161],
      mapColumns: {
        address: {
          label: '地址'
        },
        code: {
          label: '用户编码'
        },
        name: {
          label: '户名'
        }
      },
      markers: {
        WATER_USER: {
          icon: 'mark',
          infoList: ['name', 'code', 'address']
          // first: {
          //   icon: 'xxx',
          //   group: ['group1', 'group2']
          // },
          // last: {
          //   icon: 'xxx',
          //   group: ['group1', 'group2']
          // }
        }
      },
      mapResource: '',
      resource: 'base/book',
      tableInitList: ['orgParentId', 'orgId', 'readingUserId', 'linkTel', 'areaCode', 'bookCode', 'totalUserNum'],
      tableFullList: ['orgParentId', 'orgId', 'readingUserId', 'linkTel', 'areaCode', 'bookCode', 'totalUserNum'],
      filterInitList: ['orgParentId', 'orgId', 'readingUserId', 'linkTel'],
      filterFullList: ['orgParentId', 'orgId', 'readingUserId', 'linkTel'],
      updateList: ['remark'],
      operation: [{
        ...operationUpdate,
        isShow () {
          return false
        }
      }, {
        name: 'map',
        label: '查看地图',
        icon: 'mark',
        tooltip: true,
        funcProps: {
          book: this
        },
        func (full) {
          const { funcProps } = full
          const { data, book } = funcProps
          book.mapResource = book.resource + '/' + data.id + '/map'
          book.dialogVisible = true
        }
      }, {
        name: 'waterUser',
        label: '明细档案',
        tooltip: true,
        icon: 'users',
        func (full) {
          const { funcProps } = full
          const id = funcProps.data.id
          const path = `/base/waterUser/${id}`
          this.$router.push(path)
        }
      }],
      columns: {
        ...fullColumns,
        code: {
          label: '区本号',
          width: 160,
          filter: {
            type: 'input',
            like: true
          }
        },
        name: {
          label: '区本名称',
          width: 160,
          filter: {
            type: 'input',
            like: true
          }
        },
        thisReadingNum: {
          label: '本期已抄户数',
          width: 160,
          filter: {
            type: 'input',
            like: true
          }
        },
        remark: {
          label: '备注',
          width: 160,
          filter: {
            type: 'input',
            like: true
          },
          form: {
            type: 'input',
            large: true,
            rules: [{
              type: 'maxLength',
              value: 120,
              message: '字数不能大于120个字'
            }]
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Book.vue?98905530